import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import CircularProgress from '@material-ui/core/CircularProgress';
import Avatar from '@material-ui/core/Avatar';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';

import { Link, Redirect, useRouteMatch } from 'react-router-dom';

import _ from 'lodash';
import EmailActions from '../../Redux/EmailRedux';
import LayoutStyles from '../../Components/Layout/Styles/LayoutStyles';

const useStyles = makeStyles(theme => ({
  layout: LayoutStyles.centered400Layout,
  paper: LayoutStyles.centered400Paper,
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    marginTop: theme.spacing(3),
  },
}));

const SignInViaEmailToken = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const match = useRouteMatch();
  const { token } = match.params;
  const dispatch = useDispatch();
  const error = useSelector(state => state.email.error);
  const isFetching = useSelector(state => state.email.isFetching);
  const emailToken = useSelector(state => state.email.emailToken);
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn);

  React.useEffect(() => {
    dispatch(EmailActions.checkEmailTokenRequest(token));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const renderErrorMessage = () => {
    const i18nErrorKeys = _.get(error, 'message', []);
    const i18nErrorMessages = i18nErrorKeys.map(errCode =>
      t(`WELLO.AUTH.EMAIL.CUSTOM.${errCode.toUpperCase()}`),
    );

    return (
      <>
        <Typography component="h1" variant="h5">
          {t('WELLO.AUTH.EMAIL.ERROR')}
        </Typography>
        <Typography className={classes.submit} variant="body1">
          {i18nErrorMessages.join(', ')}
        </Typography>
        <Typography variant="body2">{t('WELLO.AUTH.EMAIL.CONNECT_VIA_SIGNIN')}</Typography>
        <Button className={classes.submit} variant="contained" component={Link} to="/signin">
          {t('LOGIN')}
        </Button>
      </>
    );
  };

  const renderLoading = () => (
    <>
      <Typography component="h1" variant="h5">
        {t('WELLO.AUTH.EMAIL.TITLE')}
      </Typography>

      <Avatar className={classes.avatar}>
        <CircularProgress />
      </Avatar>

      <Typography component="h1" variant="h5">
        {t('WELLO.AUTH.EMAIL.WAIT')}
      </Typography>
    </>
  );

  if (!isFetching && isLoggedIn && emailToken && emailToken.redirect_to) {
    const redirectPath = emailToken.redirect_to.replace(
      `${document.location.protocol}//${document.location.host}`,
      '',
    );
    return <Redirect to={redirectPath} />;
  }
  return (
    <>
      <Grid container className={classes.layout}>
        <Paper className={classes.paper}>
          {error && !isFetching && renderErrorMessage()}
          {!error && isFetching && renderLoading()}
        </Paper>
      </Grid>
    </>
  );
};

export default SignInViaEmailToken;
